export const LONG_TERM_PLANNING_DAYS = 31
